import Request from './../request';

import { IOrderResourceShort } from '../../props/orders';

// import interfaces

const OrderService = {
  retrieve: async (): Promise<IOrderResourceShort[]> => {
    try {
      const results = await Request.get(`/api/orders`);
      return results;
    } catch (e) {
      throw e;
    }
  },
  create: async (data: FormData): Promise<IOrderResourceShort> => {
    try {
      const results = await Request.post(`/api/orders`, data, 'multipart/form-data');
      return results;
    } catch (e) {
      throw e;
    }
  },
  update: async (data: FormData, id: string): Promise<IOrderResourceShort[]> => {
    try {
      const results = await Request.post(`/api/orders/${id}?_method=PUT`, data, 'multipart/form-data');
      return results;
    } catch (e) {
      throw e;
    }
  },
  delete: async (id: string): Promise<IOrderResourceShort[]> => {
    try {
      const results = await Request.delete(`/api/orders/${id}`);
      return results;
    } catch (e) {
      throw e;
    }
  },
};

export default OrderService;
